"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EQueueNames = exports.ERoutingKeys = void 0;
exports.getGenericRoutingKey = getGenericRoutingKey;
exports.getSpicificRoutingKey = getSpicificRoutingKey;
var ERoutingKeys;
(function (ERoutingKeys) {
    ERoutingKeys["profileExists"] = "GW.PROFILE.EXISTS";
    ERoutingKeys["getProfile"] = "GW.PROFILE.GET";
    ERoutingKeys["passwordReset"] = "PS.PROFILE.PASSWORD_RESET";
    ERoutingKeys["createProfile"] = "WP.USER.CREATED.";
    ERoutingKeys["updateProfile"] = "WP.USER.UPDATED.";
    ERoutingKeys["deleteProfile"] = "WP.USER.DELETED.";
    ERoutingKeys["addOrgToProfile"] = "WP.USER.ADDORG.";
    ERoutingKeys["removeOrgFromProfile"] = "WP.USER.REMOVEORG.";
    ERoutingKeys["wpUserRemove"] = "WP.USER.REMOVE.";
    ERoutingKeys["wpUserRemoveInvite"] = "WP.USER.REMOVE_INVITE.";
    ERoutingKeys["wpItineraryGetInfo"] = "WP.ITINERARY.GET_INFO.";
    ERoutingKeys["wpStatisticsGet"] = "WP.STATISTIC.GET.";
    ERoutingKeys["wpItineraryGetShareCodeInfo"] = "WP.ITINERARY.GET_SHARE_CODE_INFO.";
    ERoutingKeys["wpAuditLogStatistics"] = "WP.AUDITLOG.STATISTIC_UPDATE.";
    ERoutingKeys["wpAuditLogCreated"] = "WP.AUDITLOG.CREATED.";
    ERoutingKeys["psUserCreated"] = "PS.USER.CREATED.";
    ERoutingKeys["psUserUpdated"] = "PS.USER.UPDATED.";
    ERoutingKeys["psUserDeleted"] = "PS.USER.DELETED.";
    ERoutingKeys["psUserAddOrg"] = "PS.USER.ADDORG.";
    ERoutingKeys["psUserRemoveOrg"] = "PS.USER.REMOVEORG.";
    ERoutingKeys["psGetAllOrgProfiles"] = "PS.PROFILES.GETALL.";
    ERoutingKeys["psUserDeleteRequest"] = "PS.USER.DELETE_REQUEST";
    ERoutingKeys["psStatisticsGet"] = "PS.STATISTIC.GET";
    ERoutingKeys["psStatisticGetTotalUsers"] = "PS.STATISTIC.GET.TOTAL_USERS";
    ERoutingKeys["psStatisticUpdateLoginTimes"] = "PS.STATISTIC.UPDATE.LOGIN_TIMES";
    ERoutingKeys["getRocketChatTokens"] = "RC.TOKENS.GET.";
    ERoutingKeys["removeOrgFromAllProfiles"] = "ACC.ORG.REMOVE.";
    ERoutingKeys["getOrganisation"] = "GW.ORGANISATION.GET";
    ERoutingKeys["createOrganisation"] = "GW.ORGANISATION.CREATE";
    ERoutingKeys["updateOrganisation"] = "GW.ORGANISATION.UPDATE";
    ERoutingKeys["getAllOrganisations"] = "GW.ORGANISATION.GETALL";
    ERoutingKeys["chatEnsureRunning"] = "CPS.CHAT.ENSURE_RUNNING.";
    ERoutingKeys["chatStatistics"] = "CPS.STATISTIC.GET";
    ERoutingKeys["chatStatusChanged"] = "CPS.CHAT.STATUS_CHANGED.";
    ERoutingKeys["osItinCodeGet"] = "OS.ITINCODE.GET";
    ERoutingKeys["osItinCodeDelete"] = "OS.ITINCODE.DELETE";
    ERoutingKeys["osItinCodeCreate"] = "OS.ITINCODE.CREATE";
    ERoutingKeys["osStatisticsGet"] = "OS.STATISTIC.GET";
    ERoutingKeys["osAuditLogStatisticsGet"] = "OS.AUDITLOG.STATISTIC.GET";
    ERoutingKeys["osMailProcessed"] = "OS.MAIL.PROCESSED";
    ERoutingKeys["osMailGetItinerary"] = "OS.MAIL.GET_ITINERARY";
    ERoutingKeys["pmStripeCreateCustomer"] = "PM.STRIPE.CREATE_CUSTOMER";
    /// Actuall Delete of Users / Orgs. Does not care for where request comes from.
    ERoutingKeys["glueDeleteOrgs"] = "GLUE.ORGANISATION.DELETE";
    ERoutingKeys["psUserDeleteActual"] = "PS.USER.ACTUALDELETE";
    ERoutingKeys["osOrgDeleteActual"] = "OS.ORGANISATION.ACTUALDELETE";
})(ERoutingKeys || (exports.ERoutingKeys = ERoutingKeys = {}));
var EQueueNames;
(function (EQueueNames) {
    EQueueNames["getProfile"] = "profile_get";
    EQueueNames["profileExists"] = "profile_exists";
    EQueueNames["createProfile"] = "ps_profile_create";
    EQueueNames["updateProfile"] = "ps_profile_update";
    EQueueNames["deleteProfile"] = "ps_profile_delete";
    EQueueNames["addOrgToProfile"] = "ps_profile_addorg";
    EQueueNames["removeOrgFromProfile"] = "ps_profile_removeorg";
    EQueueNames["passwordReset"] = "ps_profile_password_reset";
    EQueueNames["getRocketChatTokens"] = "rc_tokens_get";
    EQueueNames["psStatisticGet"] = "ps_statistic_get";
    EQueueNames["psStatisticGetTotalUsers"] = "ps_statistic_get_total_users";
    EQueueNames["psStatisticUpdateLoginTimes"] = "ps_statistic_update_login_times";
    EQueueNames["removeOrgFromAllProfiles"] = "acc_org_remove";
    EQueueNames["organisationGet"] = "os_organisation_get";
    EQueueNames["organisationCreate"] = "os_organisation_create";
    EQueueNames["organisationUpdate"] = "os_organisation_update";
    EQueueNames["organisationGetAll"] = "os_organisation_getall";
    EQueueNames["osItinCodeDelete"] = "os_itincode_delete";
    EQueueNames["osItinCodeCreate"] = "os_itincode_create";
    EQueueNames["osItinCodeGet"] = "os_itincode_get";
    EQueueNames["osStatisticsGet"] = "os_statistic_get";
    EQueueNames["osAuditLogStatisticsGet"] = "os_audit_log_statistic_get";
    EQueueNames["osMailProcessed"] = "os_mail_processed";
    EQueueNames["osMailGetItinerary"] = "os_mail_get_itinerary";
    EQueueNames["psGetAllOrgProfiles"] = "ps_profiles_getall";
    EQueueNames["cpsEnsureRunning"] = "cps_chat_ensure_running";
    EQueueNames["cpsStatisticsGet"] = "cps_statistic_get";
    EQueueNames["psUserDeleteRequest"] = "ps_user_delete_request";
    EQueueNames["wpUserRemove"] = "wp_user_remove";
    EQueueNames["wpUserRemoveInvite"] = "wp_user_remove_invite";
    EQueueNames["wpItineraryGetInfo"] = "wp_itinerary_get_info";
    EQueueNames["wpStatisticsGet"] = "wp_statistic_get";
    EQueueNames["wpItineraryGetShareCodeInfo"] = "wp_itinerary_get_share_code_info";
    EQueueNames["wpAuditLogStatisticsUpdate"] = "wp_audit_log_statistics_update";
    EQueueNames["wpAuditLogCreate"] = "wp_audit_log_create";
    EQueueNames["pmStripeCreateCustomer"] = "pm_stripe_create_customer";
    /// Actuall Delete of Users / Orgs. Does not care for where request comes from.
    EQueueNames["glueDeleteOrgs"] = "glue_organisation_delete";
    EQueueNames["psUserDeleteActual"] = "ps_user_actualdelete";
    EQueueNames["osOrgDeleteActual"] = "os_organisation_actualdelete";
})(EQueueNames || (exports.EQueueNames = EQueueNames = {}));
/**
 * @description Adds '#' to end of routing key enum string
 * @param queue
 * @returns
 */
function getGenericRoutingKey(queue) {
    return queue + '#';
}
/**
 * @description Adds orgName to routing key enum string
 * @param queue
 * @param orgName
 * @returns
 */
function getSpicificRoutingKey(queue, orgName) {
    return queue + orgName;
}
